import ComingSoon from "components/ComingSoon";
import React from "react";

const GoogleSheet = () => {
  return <ComingSoon />;
};

export default GoogleSheet;
